/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CopyWorkspaceFromExistingResponse } from '../../models/copy-workspace-from-existing-response';

export interface CopyWorkspaceFromExisting$Params {

/**
 * Workspace ID
 */
  workspaceId: number;

/**
 * New workspace ID
 */
  newWorkspaceId: number;
}

export function copyWorkspaceFromExisting(http: HttpClient, rootUrl: string, params: CopyWorkspaceFromExisting$Params, context?: HttpContext): Observable<StrictHttpResponse<CopyWorkspaceFromExistingResponse>> {
  const rb = new RequestBuilder(rootUrl, copyWorkspaceFromExisting.PATH, 'post');
  if (params) {
    rb.path('workspaceId', params.workspaceId, {});
    rb.path('newWorkspaceId', params.newWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CopyWorkspaceFromExistingResponse>;
    })
  );
}

copyWorkspaceFromExisting.PATH = '/workspaces/{workspaceId}/from-existing/{newWorkspaceId}';
